var map = {
	"./bni.png": 88412,
	"./credit-card.png": 50805,
	"./dana.png": 23786,
	"./link-aja.png": 35195,
	"./mandiri.png": 2087,
	"./maybank.png": 93773,
	"./ovo.png": 72681,
	"./permata.png": 88911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43839;